import { FetchStatus } from '@server/fetch_status.type';
import type { CrmOrg } from '../../types/CrmOrgs';

export const isOrgConnectionError = (fetchStatus?: FetchStatus) =>
  fetchStatus ? [FetchStatus.InvalidCredentials, FetchStatus.Error].includes(fetchStatus) : false;

export const shouldReconnectEnv = (env: CrmOrg) =>
  (env.fetchStatus === FetchStatus.Error && env.lastFetchedAt === null) ||
  env.fetchStatus === FetchStatus.InvalidCredentials;
